module.exports = __webpack_public_path__ + "static/img/bg-es.6b9c52cd.webp";